import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <>
    <path
      d="M11.8597 2.1959C11.9686 1.86088 12.4425 1.86088 12.5514 2.1959L14.7365 8.92078C14.7851 9.07061 14.9248 9.17205 15.0823 9.17205H22.1532C22.5055 9.17205 22.652 9.62282 22.367 9.82987L16.6465 13.9861C16.519 14.0787 16.4657 14.2428 16.5144 14.3926L18.6994 21.1175C18.8083 21.4525 18.4248 21.7311 18.1398 21.5241L12.4193 17.3679C12.2919 17.2753 12.1193 17.2753 11.9918 17.3679L6.2713 21.5241C5.98631 21.7311 5.60287 21.4525 5.71172 21.1175L7.89677 14.3926C7.94545 14.2428 7.89212 14.0787 7.76467 13.9861L2.04414 9.82987C1.75916 9.62282 1.90562 9.17205 2.25788 9.17205H9.32884C9.48638 9.17205 9.626 9.07061 9.67468 8.92078L11.8597 2.1959Z"
      fill="url(#paint0_linear_2614_665)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2614_665"
        x1="1.81802"
        y1="8.36371"
        x2="19.9998"
        y2="21.4546"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BF9B1B" />
        <stop offset="0.355769" stopColor="#E0C870" />
        <stop offset="0.576923" stopColor="#C09E21" />
        <stop offset="1" stopColor="#5F4B00" />
      </linearGradient>
    </defs>
  </>,
  'GoldStar'
);
